import React from 'react';
import { FileQuestion } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface EmptyStateProps {
  message?: string;
  actionLabel?: string;
  onAction?: () => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({ 
  message = "No data available for this section.",
  actionLabel,
  onAction
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-6">
      <FileQuestion className="h-8 w-8 text-muted-foreground mb-4" />
      <p className="text-base text-muted-foreground text-center mb-6">
        {message}
      </p>
      {onAction && actionLabel && (
        <Button 
          variant="outline" 
          onClick={onAction}
          className="border-border hover:bg-muted"
        >
          {actionLabel}
        </Button>
      )}
    </div>
  );
};

export default EmptyState;
